module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.156 0H8.041c-1.112 0-2.01.997-2.01 2.107v1.914h20.104c1.112 0 2.01.997 2.01 2.107v11.966h2.01c1.112 0 2.01-.802 2.01-1.914V2.107c0-1.11-.899-2.107-2.01-2.107zm-6.031 6.031H2.01C.904 6.031 0 7.052 0 8.182v16.039c0 1.13.905 1.914 2.01 1.914h7.479l10.812 5.611c1.001.491 1.813.3 1.813-.834v-4.777h2.01c1.106 0 2.01-.784 2.01-1.914V8.182c0-1.13-.905-2.151-2.01-2.151z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/chat-1.js
// module id = 1054
// module chunks = 14